import { toast } from 'react-toastify';
import { callApi } from '../../../../../../../apiCaller';
import {
     API_SYSTEM_ADMIN_ADD_SEAT_EVENT,
     API_SYSTEM_ADMIN_PRODUCT_EVENTS,
     API_SYSTEM_ADMIN_REMOVE_SEAT_EVENT,
     SEAT_STATUS,
     API_SYSTEM_ADMIN_GET_EVENTS_TO_MOVE,
     DEFAULT_FN,
     API_SYSTEM_ADMIN_ADD_MULTIPLE_SEAT_EVENT,
     SEAT_STEPS,
     DEFAULT_PAGINATION_SEAT_TABLE_INIT,
} from '../../../../../../../constants';
import _ from 'lodash';
import { cloneDeep, toastError, validateEmail } from '../../../../../../../utils';
import { setAdminProductDetails } from '../../ProductDetails/actions';

export const ADD_ADMIN_ORDERS_BY_EVENTS = 'addAdminOrdersByEvents';
export const ADMIN_GET_USERS_BY_EVENTS = 'adminUsersByEvent';

export const addAdminOrdersByEvents = (orders) => {
     return {
          type: ADD_ADMIN_ORDERS_BY_EVENTS,
          payload: orders,
     };
};
export const adminUsersByEvent = (users) => {
     return {
          type: ADMIN_GET_USERS_BY_EVENTS,
          payload: users,
     };
};

export const fetchAdminEventsRequest = (nextDispatch) => (dispatch, getState) => {
     const { productId, isLoading, setIsLoading, paginationPayload, setIsFirstLoading = DEFAULT_FN } = nextDispatch;

     const { page, pageSize, filter } = paginationPayload;

     const { searchValue, optionsHide } = filter;

     const checkOptionsHide = Object.values(optionsHide).some((value) => value);
     const isEmptySearchValue = _.isEmpty(searchValue);

     const queryFilter = checkOptionsHide || !isEmptySearchValue ? `&filter=${encodeURIComponent(JSON.stringify(filter))}` : '';

     !isLoading && setIsLoading(true);

     callApi(`${API_SYSTEM_ADMIN_PRODUCT_EVENTS.replace(':id', productId)}?page=${page}&pageSize=${pageSize}${queryFilter}`, 'GET').then(
          (response) => {
               setIsLoading(false);
               setIsFirstLoading(false);

               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               const { rows, count } = response.data;

               const productDetail = cloneDeep(getState().admin.productDetails);
               productDetail.events = { rows, count };

               dispatch(setAdminProductDetails(productDetail));
          }
     );
};

// fetch events to Move
export const fetchOtherEventsToMove = (seat, setListEventToMove, setLoading) => (dispatch) => {
     setLoading(true);

     callApi(API_SYSTEM_ADMIN_GET_EVENTS_TO_MOVE.replace(':productId', seat.productId).replace(':userId', seat.userId), 'GET').then((response) => {
          setLoading(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newListEventToMove = response.data;

          setListEventToMove(newListEventToMove);
     });
};

// admin remove seat or move seat
export const adminHandleRemoveSeat = (nextDispatch) => (dispatch) => {
     const {
          seat,
          setSelectedSeat,
          checkRemove,
          setLoading,
          usersByEvent,
          setShowCheckRemovePopup,
          listSeatsEvent,
          setListSeatsEvent,
          payload,
          setSeatsEventData,
          seatsEventData,
          setIsNotUseAnySeats,
          setOrgCanAssign,
          setSeatsOpen,
          orgSeatId,
          setSeatsNoFill,
     } = nextDispatch;

     setLoading(true);
     let newListSeatsEvent = { ...listSeatsEvent };

     callApi(API_SYSTEM_ADMIN_REMOVE_SEAT_EVENT.replace(':id', seat.id), 'DELETE', payload).then((response) => {
          setLoading(false);
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          if (!seat.organizationId) {
               newListSeatsEvent = listSeatsEvent.map((oldSeat) => {
                    if (oldSeat.id === seat.id) {
                         const newSeat = {
                              eventId: seat.eventId,
                              number: seat.number,
                         };

                         return newSeat;
                    } else {
                         return oldSeat;
                    }
               });
          }

          if (seat.organizationId) {
               newListSeatsEvent = listSeatsEvent.map((oldSeat) => {
                    if (oldSeat.id === seat.id) {
                         const newSeat = seat.productCredit
                              ? { eventId: seat.eventId, number: seat.number }
                              : {
                                     ...oldSeat,
                                     user: '',
                                     userId: null,
                                     status: SEAT_STATUS.OPEN,
                                     token: '',
                                     emailInvite: '',
                                     filledAt: null,
                                     reservedAt: null,
                                     reservationExpiredAt: null,
                                     number: seat.number,
                                };

                         return newSeat;
                    } else {
                         return oldSeat;
                    }
               });
          }

          const eventAfter = response.data.eventAfter;

          setIsNotUseAnySeats(eventAfter.maxSeats === eventAfter.remainingSeats);

          setSeatsEventData({ ...seatsEventData, rows: newListSeatsEvent });
          setListSeatsEvent(newListSeatsEvent);
          setOrgCanAssign(response.data.orgCanAssign);

          const newUser = {
               id: seat.userId,
               email: seat.emailInvite,
          };
          if (usersByEvent?.length) {
               const newUserSelect = [...usersByEvent];
               newUserSelect.push(newUser);

               dispatch(adminUsersByEvent(newUserSelect));
          }
          setSeatsOpen((prevSeatsOpen) => {
               const newSeatOpen = prevSeatsOpen + 1;
               return newSeatOpen;
          });

          if (!orgSeatId) {
               setSeatsNoFill((prevSeatsNoFill) => {
                    const newSeatsNoFill = prevSeatsNoFill + 1;
                    return newSeatsNoFill;
               });
          }

          setShowCheckRemovePopup(false);
          setSelectedSeat(undefined);

          checkRemove ? toast.success('Remove seat successfully') : toast.success('Move seat successfully');
     });
};

//admin add seat to this user
export const adminAddSeatEvent = (nextDispatch) => (dispatch) => {
     const {
          productId,
          eventId,
          userId,
          userEmail,
          suppressEmail,
          usersFillSeat,
          setUsersFillSeat,
          showCheckAddPopup,
          listSeatsEvent,
          setListSeatsEvent,
          setShowCheckAddPopup,
          seatsEventData,
          setSeatsEventData,
          listAssignedOrg,
          setListAssignedOrg,
          orgSeatId,
          setIsSubmitting,
          setIsNotUseAnySeats,
          setOrgCanAssign,
          userCreatePayload,
          setSeatsOpen,
          setSeatsNoFill,
     } = nextDispatch;

     setIsSubmitting(true);

     const payload = {
          userId,
          productId,
          userEmail,
          suppressEmail,
          orgSeatId,
          userCreatePayload,
     };

     callApi(API_SYSTEM_ADMIN_ADD_SEAT_EVENT.replace(':id', eventId), 'POST', payload).then((response) => {
          setIsSubmitting(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newSeat = response.data.seat;
          // update list select users when after add seat
          const newUserSelect = usersFillSeat.rows.filter((user) => user.id !== userId);
          setUsersFillSeat(newUserSelect);
          // update list select user in redux
          dispatch(adminUsersByEvent(newUserSelect));
          // update list seats event when after add seat
          const newListSeatsEvent = listSeatsEvent.map((seat) => {
               if (seat.number === showCheckAddPopup) {
                    newSeat.number = showCheckAddPopup;
                    return newSeat;
               }
               return seat;
          });

          setIsNotUseAnySeats(newSeat.event.maxSeats === newSeat.event.remainingSeats);

          setSeatsEventData({ ...seatsEventData, rows: newListSeatsEvent });
          setListSeatsEvent(newListSeatsEvent);

          const newListAssignedOrg = listAssignedOrg.filter((org) => !org.isTemp);
          setListAssignedOrg(newListAssignedOrg);

          setOrgCanAssign(response.data.orgCanAssign);

          setSeatsOpen((prevSeatsOpen) => {
               const newSeatOpen = prevSeatsOpen - 1;
               return newSeatOpen;
          });

          if (!orgSeatId) {
               setSeatsNoFill((prevSeatsNoFill) => {
                    const newSeatsNoFill = prevSeatsNoFill - 1;

                    return newSeatsNoFill;
               });
          }

          //close pop when add seats success
          setShowCheckAddPopup(false);
          toast.success('Fill seat successfully');
     });
};

export const adminAddMultipleSeat = (nextDispatch) => (dispatch) => {
     const {
          productId,
          eventId,
          organizationId,
          country,
          timezone,
          emails,
          suppressEmail,
          setIsSubmitting,
          setCurrentStep,
          setBulkAddSeatResults,
          setPagination,
          fetchSeatsEvent,
          setIsNotUseAnySeats,
     } = nextDispatch;

     setIsSubmitting(true);

     const newEmails = [];
     const emailErrors = [];

     //validation emails
     for (let i = 0; i < emails.length; i++) {
          const email = emails[i].toLowerCase().trim();

          if (!email) {
               continue;
          }

          if (!validateEmail(email)) {
               emailErrors.push(email);
               continue;
          }
          newEmails.push(email);
     }

     if (!newEmails.length) {
          setBulkAddSeatResults((prevSeatAssignmentResults) => {
               return {
                    ...prevSeatAssignmentResults,
                    failed: {
                         ...prevSeatAssignmentResults.failed,
                         items: emailErrors,
                    },
               };
          });

          setCurrentStep(SEAT_STEPS.SEAT_ASSIGNMENT_COMPLETE);
          setIsSubmitting(false);
          return;
     }

     const payload = {
          productId,
          organizationId,
          country,
          timezone,
          emails: newEmails,
          suppressEmail,
     };
     callApi(API_SYSTEM_ADMIN_ADD_MULTIPLE_SEAT_EVENT.replace(':id', eventId), 'POST', payload).then((response) => {
          setIsSubmitting(false);
          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const {
               successfully: successfullyItems,
               failed: failedItems,
               hasAwaitingItem: hasAwaitingItems,
               alreadySeat: alreadyAssignedItems,
          } = response.data.result;

          setCurrentStep(SEAT_STEPS.SEAT_ASSIGNMENT_COMPLETE);

          setBulkAddSeatResults((prevSeatAssignmentResults) => {
               return {
                    ...prevSeatAssignmentResults,
                    ...(successfullyItems.length && {
                         successfully: {
                              ...prevSeatAssignmentResults.successfully,
                              items: successfullyItems,
                         },
                    }),
                    ...((emailErrors.length || failedItems.length) && {
                         failed: {
                              ...prevSeatAssignmentResults.failed,
                              items: [...emailErrors, ...failedItems],
                         },
                    }),
                    ...(hasAwaitingItems.length && {
                         hasAwaitingItem: {
                              ...prevSeatAssignmentResults.hasAwaitingItem,
                              items: hasAwaitingItems,
                         },
                    }),
                    ...(alreadyAssignedItems.length && {
                         alreadyAssigned: {
                              ...prevSeatAssignmentResults.alreadyAssigned,
                              items: alreadyAssignedItems,
                         },
                    }),
               };
          });

          const newSeat = response.data.items[0];
          if (newSeat) setIsNotUseAnySeats(newSeat.event.maxSeats === newSeat.event.remainingSeats);
          // Reset filter table
          const paginationPayload = {
               ...DEFAULT_PAGINATION_SEAT_TABLE_INIT,
          };
          setPagination((currentPagination) => {
               paginationPayload.pageSize = currentPagination.pageSize;

               return paginationPayload;
          });
          fetchSeatsEvent(paginationPayload);
     });
};
